<template>
  <div class="course-head" :class="className" :style="wrapStyle">
    <div class="course-head-l">
      <img :src="data.coverImg" alt="">
    </div>
    <div class="course-head-r">
      <div class="course-head__name diandiandian-multiple">{{data.name}}</div>
      <div class="course-head__desc">{{data.goodsDesc}}</div>
      <div class="course-head-tips" v-if="data.tags">
        <span v-for="tag in data.tags" :key="tag.code">{{tag.tagName}}</span>
      </div>
      <!-- <div class="course-head__trainees" v-if="data.courseStudyCount">{{data.courseStudyCount}}人已加入学习</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'CourseHead',
  props: {
    themeType: {
      type: [String, Number],
      default: ''
    },
    themeStyle: {
      type: Object,
      default: () => ({})
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    };
  },
  computed: {
    wrapStyle() {
      return this.themeStyle;
    },
    className() {
      return { 'course-head-theme--black': this.themeType == 'black' };
    }
  },
};
</script>

<style lang="stylus" scoped>
.course-head {
  display: flex;
  padding: 20px;
  color: #FFFFFF;
  &.course-head-theme--black {
    color: #41414D;
    .course-head-tips {
      span {
        color: #A1A1B3;
        background: #F5F5FA;
      }
    }
  }
  .course-head-l {
    width: 98px;
    min-width: 98px;
    height: 129px;
    margin-right:  20px;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
      border-radius: 8px;
    }
  }

  .course-head__name {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: bold;
    line-height: 22px;
  }
  .course-head__desc {
    margin-top: 6px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 18px;
  }
  .course-head-tips {
    margin-top: 10px;
    span {
      display: inline-block;
      margin-right: 10px;
      margin: 0 10px 5px 0;
      padding: 2px 8px;
      line-height: 16px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 10px;
    }
  }
  .course-head__trainees {
    margin-top: 5px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 16px;
  }
}
</style>